export default __webpack_public_path__ + "static/media/flatout-blue.5e2640c7.jpg";